module.exports = __webpack_public_path__ + "static/img/unite-logo.3e56643.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zbqfBrand/unite-logo.png
// module id = EpuT
// module chunks = 0